module.exports = __webpack_public_path__ + "img/people5.b0dfc854.png";